import { IColor, IMold } from "../../../types/data.interface";
import {
  formatColorIntoOption,
  getColors,
} from "../../../helpers/color.helper";
import { Predicates } from "../../../libraries/predicates/predicates";
import OptionFormatter from "../../../components/OptionFormatter";
import AsyncSelect from "react-select/async";
import { useColorContext } from "../../../context/ColorContext";
import { fetchColor } from "../../../hooks/useColor";
import {
  DebounceContext,
  DebounceContextType,
} from "../../../context/DebounceContext";
import useAxios from "../../../utils/useAxios";
import { useContext } from "react";

interface IPrintingTechniqueColorAsyncSelectProps {
  onChanged: (...args: any[]) => void;
  value?: IColor;
  isDisabled?: boolean;
  isMandatory?: boolean;
}

export const PrintingTechniqueColorAsyncSelect = ({
  isDisabled = false,
  isMandatory = false,
  onChanged,
  value,
}: IPrintingTechniqueColorAsyncSelectProps) => {
  const { data: colors, isLoading: isColorsLoading } = useColorContext();
  const axios = useAxios();
  const { searchDebounce } = useContext<DebounceContextType>(DebounceContext);

  const loadColorOptions = async (search: string, callback: any) => {
    if (Predicates.isNullOrUndefined(search) || search.length < 3) return [];
    const response = await fetchColor({
      search,
      axios,
    });

    callback(getColors(response));
  };

  const handleUpdateMolds = (e: any) => {
    onChanged(e ? e.value : null);
  };

  return (
    <>
      <label className="form-label">
        Color {isMandatory && <span className="red-text fw-bold">*</span>}
      </label>
      <AsyncSelect
        cacheOptions
        loadOptions={(input, callback) => {
          searchDebounce(loadColorOptions, input, getColors(colors), callback);
        }}
        defaultOptions={getColors(colors)}
        onChange={handleUpdateMolds}
        value={
          Predicates.isNotNullAndNotUndefined(value)
            ? formatColorIntoOption(value)
            : null
        }
        placeholder="(min 3 characters)"
        formatOptionLabel={OptionFormatter}
        classNamePrefix="react-select"
        isClearable
        isLoading={isColorsLoading}
        components={{
          IndicatorSeparator: () => null,
        }}
        isDisabled={isDisabled}
      />
    </>
  );
};
